import React, { memo, useState } from "react";
import "./styles.scss";
import { Toggleup, Toggledown } from "Res/icons";
import CloseButton from "Components/CloseButton";
import ModelNew from "Components/Model/ModelNew";

const InfoDetails = ({ translate, openModel, setOpenModel, servicesDetailsData }) => {
  const details = servicesDetailsData?.content?.categoryDetails;
  const faqList = servicesDetailsData?.content?.faq || [];

  const [selectedCategory, setSelectedCategory] = useState(null);

  const toggleAction = (index) => {
    setSelectedCategory(prev => (prev === index ? null : index));
  };

  const renderFaq = faqList.map((item, index) => (
    <div
      className={`sidebar__accordion__section py-1 ${selectedCategory === index ? "active" : ""}`}
      key={`mundo__details_${index}`}
    >
      <div className="flex parent md-pb-3 gap-4">
        <div className="toggle__arrow flex middle" onClick={() => toggleAction(index)}>
          {selectedCategory === index ? <Toggleup role="presentation" /> : <Toggledown role="presentation" />}
        </div>
        <p
          className="flex-1 pr-3 fw-700 pointer"
          onClick={() => toggleAction(index)}
        >
          {item?.faq_title}
        </p>
      </div>
      {selectedCategory === index && (
        <div className="answers flex pb-1 pl-8">
          <p dangerouslySetInnerHTML={{ __html: item?.faq_detail_description }} />
        </div>
      )}
    </div>
  ));

  return (
    <ModelNew
      from="right"
      hideScroll={false}
      zindex={11}
      open={openModel}
      shadow={true}
      setOpen={setOpenModel}
      className="mondu__payment__sidebar"
    >
      <div className="sidebar__details w-1/1 h-1/1 p-5 xl-px-7 xl-pt-10 xl-pb-7 overflow-hidden overflow-y-auto" style={{ fontSize: 15, lineHeight: "30px" }}>
        <div className="relative">
          <div className="closeButton absolute top-0 right-0">
            <CloseButton onClickFunction={() => setOpenModel(false)} />
          </div>
        </div>

        <div className="flex col h-1/1">
          {(details?.category_name || details?.category_description) && (
            <div className="flex col sidebar__contents mb-5 md-mb-8 pt-8">
              <div className="sidebar__heading pb-3 mb-3 flex col start gap-4 sm-flex sm-row sm-middle">
                <h1 className="fw-700">
                  {translate?.[details?.category_name?.toLowerCase()] || details?.category_name}
                </h1>
              </div>
              {details?.category_description && (
                <div className="sidebar__content w-1/1 h-1/1">
                  <p
                    className="mb-4"
                    dangerouslySetInnerHTML={{ __html: details.category_description }}
                  />
                </div>
              )}
            </div>
          )}

          {!details?.hideVragen && faqList.length > 0 && (
            <div className="sidebar__accordion">
              {openModel && (
                <div className="pt-4 pb-5">
                  <h1 className="fw-700 texthidecontent">Veelgestelde vragen</h1>
                </div>
              )}
              <div>{renderFaq}</div>
            </div>
          )}
        </div>
      </div>
    </ModelNew>
  );
};

export default memo(InfoDetails);
